import { Reveal, Kicker } from "@/components/Reveal";
import { ArrowRight, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ParticipateSection = ({ t }) => (
  <section id="participate" data-testid="participate-section" className="relative py-24 sm:py-32 px-6 bg-[#1A1715]">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <Kicker>{t.participate.kicker}</Kicker>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F0E6] max-w-3xl">
          {t.participate.title}
        </h2>
        <p className="text-base text-[#A8A294] mt-6 max-w-xl leading-relaxed">{t.participate.desc}</p>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6 mt-16">
        {t.participate.cards.map((card, i) => {
          const isBrochure = card.href === "brochure";
          return (
            <Reveal key={card.title} delay={0.1 + i * 0.12}>
              <div data-testid={`participate-card-${i}`} className="border border-[#F4F0E6]/10 bg-[#0D0B0A] p-8 h-full flex flex-col">
                <h3 className="font-heading text-2xl text-[#F4F0E6]">{card.title}</h3>
                <p className="text-sm text-[#A8A294] mt-4 leading-relaxed flex-1">{card.desc}</p>
                <a
                  href={isBrochure ? `${API}/brochure` : card.href}
                  data-testid={`participate-cta-${i}`}
                  className="inline-flex items-center gap-2 mt-8 text-sm text-[#D4A373] hover:text-[#B87B41] transition-colors"
                >
                  {isBrochure ? <Download size={15} /> : <ArrowRight size={15} />}
                  {card.cta}
                </a>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
